'use client';

import { LucideIcon, X } from 'lucide-react';
import { toast as sonnerToast } from 'sonner';
import { Button } from '@/components/ui/button';

/** Restored your abstraction with the dismiss/duration logic */
export function toast(toast: Omit<ToastProps, 'id'>) {
  return sonnerToast.custom((id) => (
    <Toast
      id={id}
      text={toast.text}
      icon={toast.icon}
      dismiss={toast.dismiss}
    />
  ), {
    // Keeps toast visible indefinitely if dismiss is true
    duration: toast.dismiss ? Infinity : 3000,
  });
}

/** Restored your exact custom formatting */
function Toast(props: ToastProps) {
  const { text, icon: Icon, id, dismiss } = props;
  
  return (
    <div className="flex flex-row justify-start items-center gap-4 rounded-md w-full bg-background md:w-[364px] p-4 shadow-[0_0px_24px_rgba(0,0,0,0.1)]">
      {Icon && (
        <div className="flex flex-col justify-center items-center w-8 h-8 bg-secondary rounded-full shrink-0">
          <Icon className="size-4 text-foreground shrink-0" />
        </div>  
      )}
      
      <div className="text-sm font-medium text-foreground flex-grow">{text}</div>

      {dismiss && (
        <Button 
          variant="ghost"
          size="icon"
          onClick={() => sonnerToast.dismiss(id)}
          className="text-muted-foreground hover:text-foreground"
        >
          <X />
        </Button>
      )}
    </div>
  );
}

interface ToastProps {
  id?: string | number;
  text: string;
  icon?: LucideIcon;
  dismiss?: boolean;
}
